import React, { useEffect, useState } from 'react';
import './Exceptions.css';

export default function Exceptions() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState('PENDING');
  const [loading, setLoading] = useState(true);

  const tabs = ['PENDING', 'APPROVED', 'REJECTED', 'ALL'];

  async function load(status = tab) {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/proposals/exception-requests?status=${encodeURIComponent(
          status
        )}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data = await res.json();
      setItems(data.items || []);
    } catch {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load('PENDING');
  }, []);

  function statusClass(s) {
    if (s === 'APPROVED') return 'child-status approved';
    if (s === 'REJECTED') return 'child-status rejected';
    return 'child-status submitted';
  }

  async function decide(id, decision) {
    const token = localStorage.getItem('token');
    const res = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/proposals/exception-requests/${id}/decide`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ decision }),
      }
    );
    if (res.ok) {
      load(tab);
    } else {
      alert('Failed to decide.');
    }
  }

  return (
    <div className="proposal-details-container">
      <div className="card">
        <div className="details-header">
          <h2>Exception Requests</h2>
          <span className="status-pill-header">
            {tab[0] + tab.slice(1).toLowerCase()}
          </span>
        </div>

        <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
          {tabs.map((t) => {
            const active = t === tab;
            return (
              <button
                key={t}
                className={`btn ${active ? 'primary' : 'ghost'}`}
                onClick={() => {
                  setTab(t);
                  load(t);
                }}
              >
                {t[0] + t.slice(1).toLowerCase()}
              </button>
            );
          })}
        </div>

      </div>
              <div className="card" style={{ marginTop: 12 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left', padding: 8 }}>Requester</th>
                <th style={{ textAlign: 'left', padding: 8 }}>Email</th>
                <th style={{ textAlign: 'left', padding: 8 }}>Reason</th>
                <th style={{ textAlign: 'left', padding: 8 }}>Status</th>
                <th style={{ textAlign: 'left', padding: 8 }}>Created</th>
                <th style={{ textAlign: 'left', padding: 8 }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr>
                  <td colSpan="6" style={{ padding: 24, textAlign: 'center' }}>
                    Loading…
                  </td>
                </tr>
              )}

              {!loading && items.length === 0 && (
                <tr>
                  <td
                    colSpan="6"
                    style={{
                      padding: 24,
                      textAlign: 'center',
                      color: 'var(--muted)',
                    }}
                  >
                    No items
                  </td>
                </tr>
              )}

              {!loading &&
                items.map((it) => (
                  <tr key={it.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                    <td style={{ padding: 8 }}>
                      {it.first_name} {it.last_name}
                    </td>
                    <td style={{ padding: 8 }}>{it.email}</td>
                    <td
                      style={{
                        padding: 8,
                        maxWidth: 360,
                        whiteSpace: 'pre-wrap',
                      }}
                    >
                      {it.reason || '-'}
                    </td>
                    <td style={{ padding: 8 }}>
                      <span className={statusClass(it.status)}>
                        {it.status[0] + it.status.slice(1).toLowerCase()}
                      </span>
                    </td>
                    <td style={{ padding: 8 }}>
                      {new Date(it.created_at).toLocaleString()}
                    </td>
                    <td style={{ padding: 8 }}>
                      {it.status === 'PENDING' ? (
                        <>
                          <button
                            className="btn primary"
                            onClick={() => decide(it.id, 'APPROVED')}
                            style={{ marginRight: 8 }}
                          >
                            Approve
                          </button>
                          <button
                            className="btn"
                            onClick={() => decide(it.id, 'REJECTED')}
                          >
                            Reject
                          </button>
                        </>
                      ) : (
                        <span className="muted">—</span>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
    </div>
  );
}
